import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Calendar() {
  const terms = [
    {
      title: "Autumn Term",
      icon: "bi-leaf",
      color: "#f59e0b",
      startDate: "Tuesday 01 September 2026",
      endDate: "Friday 18 December 2026",
      halfTerm: "Monday 26 – Friday 30 October 2026",
      holiday: { name: "Christmas Holiday 2026", dates: "Monday 21 December 2026 to Monday 04 January 2027" }
    },
    {
      title: "Spring Term",
      icon: "bi-flower1",
      color: "#B17ACC",
      startDate: "Tuesday 05 January 2027",
      endDate: "Thursday 25 March 2027",
      halfTerm: "Monday 15 – Friday 19 February 2027",
      holiday: { name: "Easter Holiday 2027", dates: "Monday 29 March 2027 to Friday 09 April 2027" }
    },
    {
      title: "Summer Term",
      icon: "bi-brightness-high",
      color: "#fbbf24",
      startDate: "Monday 12 April 2027",
      endDate: "Friday 02 July 2027",
      halfTerm: "Monday 31 May – Friday 04 June 2027"
    }
  ];

  const bankHolidays = [
    { name: "Good Friday", date: "Friday 26 March 2027" },
    { name: "Easter Monday", date: "Monday 29 March 2027" },
    { name: "Early May Bank Holiday", date: "Monday 3 May 2027" },
    { name: "Spring Bank Holiday", date: "Monday 31 May 2027" },
    { name: "Summer Bank Holiday", date: "Monday 30 August 2027" },
    { name: "Christmas Day", date: "Monday 27 December 2027" },
    { name: "Boxing Day", date: "Tuesday 28 December 2027" }
  ];

  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    📅 ACADEMIC CALENDAR
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Academic Calendar
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Term dates 2026/27
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        <section id="calendar" className="calendar section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            {/* Notice */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-4 shadow" style={{ 
                  backgroundColor: '#F5EBFA',
                  borderRadius: '16px',
                  border: '2px solid #B17ACC',
                  textAlign: 'center'
                }} data-aos="fade-up" data-aos-delay="50">
                  <div style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 15px',
                    border: '3px solid #B17ACC'
                  }}>
                    <i className="bi bi-info-circle" style={{ fontSize: '1.8rem', color: '#B17ACC' }}></i>
                  </div>
                  <p style={{ color: '#6B2F8E', fontSize: '1.05rem', marginBottom: '0', fontWeight: '500' }}>
                    These dates are for part-time classroom-based students. All other students should check with your tutor.
                  </p>
                </div>
              </div>
            </div>

            {/* Term Dates */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="text-center mb-5">
                  <div style={{
                    display: 'inline-block',
                    backgroundColor: '#F5EBFA',
                    color: '#7B3F9E',
                    padding: '8px 20px',
                    borderRadius: '50px',
                    marginBottom: '20px',
                    border: '2px solid #D4BFE3',
                    fontSize: '0.9rem',
                    fontWeight: '600'
                  }}>
                    📅 TERM DATES
                  </div>
                  <h2 style={{ 
                    color: '#1e293b', 
                    fontSize: '2rem',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    Academic Terms
                  </h2>
                </div>
                
                {terms.map((term, index) => (
                  <div key={index} className="mb-4" data-aos="fade-up" data-aos-delay={100 + (index * 50)}>
                    <div className="p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '20px',
                      borderLeft: `5px solid ${term.color}`,
                      transition: 'all 0.3s ease',
                      border: '1px solid #e2e8f0'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(8px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          width: '60px',
                          height: '60px',
                          backgroundColor: `${term.color}15`,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '20px',
                          border: `3px solid ${term.color}`
                        }}>
                          <i className={`${term.icon}`} style={{ fontSize: '1.8rem', color: term.color }}></i>
                        </div>
                        <h3 style={{ 
                          color: '#1e293b', 
                          fontSize: '1.6rem', 
                          marginBottom: '0',
                          fontWeight: '700',
                          letterSpacing: '-0.3px'
                        }}>
                          {term.title}
                        </h3>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <div className="d-flex align-items-start">
                            <div style={{
                              width: '40px',
                              height: '40px',
                              backgroundColor: '#F5EBFA',
                              borderRadius: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '12px',
                              flexShrink: 0
                            }}>
                              <i className="bi bi-calendar-event" style={{ color: '#7B3F9E', fontSize: '1.2rem' }}></i>
                            </div>
                            <div>
                              <strong style={{ color: '#7B3F9E', display: 'block', fontSize: '0.95rem' }}>Term Dates</strong>
                              <span style={{ color: '#475569', fontSize: '0.95rem' }}>{term.startDate} to {term.endDate}</span>
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-md-6 mb-3">
                          <div className="d-flex align-items-start">
                            <div style={{
                              width: '40px',
                              height: '40px',
                              backgroundColor: '#F5EBFA',
                              borderRadius: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '12px',
                              flexShrink: 0
                            }}>
                              <i className="bi bi-calendar-x" style={{ color: '#7B3F9E', fontSize: '1.2rem' }}></i>
                            </div>
                            <div>
                              <strong style={{ color: '#7B3F9E', display: 'block', fontSize: '0.95rem' }}>Half Term</strong>
                              <span style={{ color: '#475569', fontSize: '0.95rem' }}>{term.halfTerm}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {term.holiday && (
                        <div className="mt-3 p-3" style={{ 
                          backgroundColor: '#F5EBFA',
                          borderRadius: '12px',
                          border: '2px solid #a7f3d0'
                        }}>
                          <div className="d-flex align-items-start">
                            <div style={{
                              width: '40px',
                              height: '40px',
                              backgroundColor: 'white',
                              borderRadius: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '12px',
                              flexShrink: 0
                            }}>
                              <i className="bi bi-snow" style={{ color: '#7B3F9E', fontSize: '1.2rem' }}></i>
                            </div>
                            <div>
                              <strong style={{ color: '#6B2F8E', display: 'block', fontSize: '0.95rem' }}>{term.holiday.name}</strong>
                              <span style={{ color: '#475569', fontSize: '0.95rem' }}>{term.holiday.dates}</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Bank Holidays */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="text-center mb-5">
                  <div style={{
                    display: 'inline-block',
                    backgroundColor: '#F5EBFA',
                    color: '#7B3F9E',
                    padding: '8px 20px',
                    borderRadius: '50px',
                    marginBottom: '20px',
                    border: '2px solid #D4BFE3',
                    fontSize: '0.9rem',
                    fontWeight: '600'
                  }}>
                    🎉 HOLIDAYS
                  </div>
                  <h2 style={{ 
                    color: '#1e293b', 
                    fontSize: '2rem',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    Bank Holidays
                  </h2>
                </div>
                
                <div className="row">
                  {bankHolidays.map((holiday, index) => (
                    <div key={index} className="col-md-6 mb-3" data-aos="fade-up" data-aos-delay={100 + (index * 30)}>
                      <div className="p-4 h-100 shadow" style={{ 
                        backgroundColor: '#fff',
                        borderRadius: '16px',
                        border: '2px solid #e2e8f0',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#F5EBFA';
                        e.currentTarget.style.borderColor = '#B17ACC';
                        e.currentTarget.style.transform = 'translateY(-3px)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#fff';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}>
                        <div className="d-flex align-items-center">
                          <div style={{
                            width: '50px',
                            height: '50px',
                            backgroundColor: '#F5EBFA',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '15px',
                            border: '2px solid #B17ACC',
                            flexShrink: 0
                          }}>
                            <i className="bi bi-calendar-check" style={{ fontSize: '1.5rem', color: '#B17ACC' }}></i>
                          </div>
                          <div>
                            <h5 style={{ 
                              color: '#1e293b', 
                              marginBottom: '5px', 
                              fontSize: '1.1rem',
                              fontWeight: '600'
                            }}>
                              {holiday.name}
                            </h5>
                            <p style={{ 
                              color: '#64748b', 
                              marginBottom: '0', 
                              fontSize: '0.95rem' 
                            }}>
                              {holiday.date}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Calendar;